import React from "react";
import styles from "./styles.module.scss";

const InstallInstruction = ({ instruction }) => {
  return <div className={styles.install_instruction}>{instruction}</div>;
};

export default InstallInstruction;
